export default {
  title: 'Resumen de ventas',
  description: 'Ventas del período seleccionado — úsalo para la conciliación de facturación con este restaurante.',
  filters: {
    period: 'Período',
  },
  presets: {
    this_month: 'Este mes',
    last_month: 'Mes pasado',
    last_30_days: 'Últimos 30 días',
    this_year: 'Este año',
  },
  fields: {
    orders_count: 'Pedidos',
    net_sales: 'Ventas netas',
    sales_tax: 'Impuesto sobre ventas',
    gross_sales: 'Ventas brutas',
    delivery_fee_tax: 'Tarifa de entrega (impuesto)',
    delivery_fee_gross: 'Tarifa de entrega (bruto)',
    tips_gross: 'Propinas (bruto)',
    total: 'Total',
  },
  kpi: {
    before_tax: 'antes de impuestos',
    tips: 'cobrado para el restaurante',
    owed_to_restaurant: 'adeudado al restaurante',
  },
  table: {
    title: 'Desglose',
    subtitle: '{{range}} · Todos los importes en {{currency}}',
    field: 'Campo',
    amount: 'Importe',
    empty: 'Sin pedidos en el período seleccionado',
    footnote:
      'Las ventas netas excluyen impuestos; las ventas brutas los incluyen · El total es neto de comisiones de plataforma, por lo que no es lo que pagó el cliente · Los reembolsos y contracargos se descuentan · Importes en {{currency}}',
  },
  buttons: {
    export_csv: 'Exportar CSV',
    refresh: 'Actualizar',
    retry: 'Intentar de nuevo',
  },
  errors: {
    failed_to_load: {
      title: 'No se pudo cargar el resumen de ventas',
      description: 'Algo salió mal al cargar el informe. Por favor, inténtalo de nuevo.',
    },
  },
};
